export default "__VITE_ASSET__BabyHeMp__"